import {
  WebSocketSessionzi1ianvyj32u as WebSocketSession,
  close2zjubq94ny3dk as close,
  closeExceptionally478f4pam77tz as closeExceptionally,
  send3vgnni2smbra3 as send,
} from './WebSocketSession.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance27kujspvp4jub as Companion_getInstance,
  from3gpkuvfyl3bft as from,
  ChannelOverflow_SUSPEND_getInstance2mwe7xoajis0a as ChannelOverflow_SUSPEND_getInstance,
  ChannelConfigftdbykui5s0q as ChannelConfig,
} from './WebSocketChannelsConfig.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Dispatchers_getInstance20p7pyqnrepag as Dispatchers_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { CoroutineStart_UNDISPATCHED_getInstance2pq896dvru5v1 as CoroutineStart_UNDISPATCHED_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import {
  Binary3tlzyfojm51s4 as Binary,
  Text3e6ukp9joohql as Text,
  Close3tx65evcwi73t as Close,
  Pong3m3cas9hmc9ec as Pong,
  Companion_getInstance31awdom2j9aye as Companion_getInstance_0,
  Ping3nta6l7sdq1r9 as Ping,
} from './Frame.web.mjs';
import {
  readReason2qq1b0s02pdpy as readReason,
  NonDisposableHandle_instance20n9avbwze9pj as NonDisposableHandle_instance,
} from './FrameCommon.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  CloseReason10cphaqpp3ct7 as CloseReason,
  Codes_NORMAL_getInstance1njykag03saqj as Codes_NORMAL_getInstance,
  Codes_CLOSED_ABNORMALLY_getInstance35h8511ldg1ec as Codes_CLOSED_ABNORMALLY_getInstance,
  Codes_TOO_BIG_getInstance2nmgczgdhdqig as Codes_TOO_BIG_getInstance,
} from './CloseReason.mjs';
import {
  pingerd16zvjbf6m9o as pinger,
  ponger270tezdl2mu68 as ponger,
} from './PingPong.mjs';
import {
  ChannelResult2y4k69ac6y3du as ChannelResult,
  _ChannelResult___get_isSuccess__impl__odq1z9t6ktwy0g0q0f as _ChannelResult___get_isSuccess__impl__odq1z9,
  ClosedSendChannelException29m33prpq9jaw as ClosedSendChannelException,
  ClosedReceiveChannelException3ofg6gf5f5b38 as ClosedReceiveChannelException,
  Factory_getInstance32nnliw9sj63p as Factory_getInstance,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import {
  get_size2imoy2jq11jxl as get_size,
  BytePacketBuilder2biodf4wxvlba as BytePacketBuilder,
  writeFully359t6q8kam2g5 as writeFully,
  buildjygoh729rhy8 as build,
} from '../../../../ktor-ktor-io/io/ktor/utils/io/core/BytePacketBuilder.mjs';
import { FrameTooBigException1rgdafsgu31sm as FrameTooBigException } from './FrameTooBigException.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { cancelConsumed2i0oizqhmljf6 as cancelConsumed } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channels.common.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { ChannelIOException2i3t76lsrbgox as ChannelIOException } from '../../../../ktor-ktor-utils/io/ktor/util/cio/Channels.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import {
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
} from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableDeferred.mjs';
import {
  Job13y4jkazwjho0 as Job,
  Key_instancebefxze3q9f64 as Key_instance,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { CoroutineName2g5zosw74tf0f as CoroutineName } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineName.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { get_OUTGOING_CHANNEL_CAPACITY2ancx42jsldm9 as get_OUTGOING_CHANNEL_CAPACITY } from './Utils.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return LOGGER;
}
var LOGGER;
function get_IncomingProcessorCoroutineName() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return IncomingProcessorCoroutineName;
}
var IncomingProcessorCoroutineName;
function get_OutgoingProcessorCoroutineName() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return OutgoingProcessorCoroutineName;
}
var OutgoingProcessorCoroutineName;
function get_NORMAL_CLOSE() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return NORMAL_CLOSE;
}
var NORMAL_CLOSE;
var OUTGOING_CHANNEL_CONFIG;
var DefaultWebSocketSessionClass;
function DefaultWebSocketSession() {
  if (DefaultWebSocketSessionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DefaultWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DefaultWebSocketSessionClass = $;
  }
  return DefaultWebSocketSessionClass;
}
function DefaultWebSocketSession_0(session, pingIntervalMillis, timeoutMillis, channelsConfig) {
  pingIntervalMillis = pingIntervalMillis === VOID ? 0n : pingIntervalMillis;
  timeoutMillis = timeoutMillis === VOID ? 15000n : timeoutMillis;
  channelsConfig = channelsConfig === VOID ? Companion_getInstance().t5b_1 : channelsConfig;
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  // Inline function 'kotlin.require' call
  if (!!isInterface(session, DefaultWebSocketSession())) {
    var message = 'Cannot wrap other DefaultWebSocketSession';
    throw IllegalArgumentException().n2(toString(message));
  }
  return new (DefaultWebSocketSessionImpl())(session, pingIntervalMillis, timeoutMillis, channelsConfig.u5b_1, channelsConfig.v5b_1);
}
function runIncomingProcessor($this, ponger) {
  var tmp = get_IncomingProcessorCoroutineName().pm(Dispatchers_getInstance().h13_1);
  return launch($this, tmp, VOID, DefaultWebSocketSessionImpl$runIncomingProcessor$slambda($this, ponger));
}
function runOutgoingProcessor($this) {
  var tmp = get_OutgoingProcessorCoroutineName().pm(Dispatchers_getInstance().h13_1);
  var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
  return launch($this, tmp, tmp_0, DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda($this));
}
function *outgoingProcessorLoop($this, $completion) {
  var _iterator__ex2g4s = $this.c5c_1.p1();
  $l$loop: while (yield* _iterator__ex2g4s.n1a($completion)) {
    var frame = _iterator__ex2g4s.r1();
    // Inline function 'io.ktor.util.logging.trace' call
    var this_0 = get_LOGGER();
    if (get_isTraceEnabled(this_0)) {
      var tmp$ret$1 = 'Sending ' + frame.toString() + ' from session ' + toString($this);
      this_0.b4u(tmp$ret$1);
    }
    var tmp;
    if (frame instanceof Close()) {
      yield* sendCloseSequence($this, readReason(frame), VOID, $completion);
      break $l$loop;
    } else {
      var tmp_0;
      if (frame instanceof Text()) {
        tmp_0 = true;
      } else {
        tmp_0 = frame instanceof Binary();
      }
      if (tmp_0) {
        tmp = processOutgoingExtensions($this, frame);
      } else {
        tmp = frame;
      }
    }
    var processedFrame = tmp;
    yield* $this.w5b_1.r5b().b1b(processedFrame, $completion);
  }
  return Unit_instance;
}
function *sendCloseSequence($this, reason, exception, $completion) {
  exception = exception === VOID ? null : exception;
  if (!tryClose($this))
    return Unit_instance;
  // Inline function 'io.ktor.util.logging.trace' call
  var this_0 = get_LOGGER();
  if (get_isTraceEnabled(this_0)) {
    var tmp$ret$1 = 'Sending Close Sequence for session ' + toString($this) + ' with reason ' + toString_0(reason) + ' and exception ' + toString_0(exception);
    this_0.b4u(tmp$ret$1);
  }
  $this.z5b_1.t12();
  var reasonToSend = reason == null ? CloseReason().z5a(Codes_NORMAL_getInstance(), '') : reason;
  try {
    runOrCancelPinger($this);
    if (!(reasonToSend.w5a_1 === Codes_CLOSED_ABNORMALLY_getInstance().s5a_1)) {
      yield* $this.w5b_1.r5b().b1b(Close().q5c(reasonToSend), $completion);
    }
  }finally {
    $this.y5b_1.r12(reasonToSend);
    if (!(exception == null)) {
      $this.c5c_1.l1b(exception);
      $this.b5c_1.l1b(exception);
    }
  }
  return Unit_instance;
}
function tryClose($this) {
  return $this.d5c_1.atomicfu$compareAndSet(false, true);
}
function runOrCancelPinger($this) {
  var interval = $this.g5c_1;
  var tmp;
  if ($this.d5c_1.kotlinx$atomicfu$value) {
    tmp = null;
  } else if (interval > 0n) {
    var tmp_0 = $this.w5b_1.r5b();
    var tmp_1 = $this.h5c_1;
    tmp = pinger($this, tmp_0, interval, tmp_1, DefaultWebSocketSessionImpl$runOrCancelPinger$slambda($this));
  } else {
    tmp = null;
  }
  var newPinger = tmp;
  var tmp0_safe_receiver = $this.x5b_1.atomicfu$getAndSet(newPinger);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.n1b();
  var tmp2_safe_receiver = newPinger == null ? null : new (ChannelResult())(newPinger.c1b(Companion_getInstance_1().r5c_1));
  if (tmp2_safe_receiver == null)
    null;
  else
    _ChannelResult___get_isSuccess__impl__odq1z9(tmp2_safe_receiver.a1b_1);
  if ($this.d5c_1.kotlinx$atomicfu$value && !(newPinger == null)) {
    runOrCancelPinger($this);
  }
}
function *checkMaxFrameSize($this, packet, frame, $completion) {
  var tmp = frame.h5b_1.length;
  var tmp1_elvis_lhs = packet == null ? null : get_size(packet);
  var size = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  if (fromInt(size) > $this.p5b()) {
    if (packet == null)
      null;
    else {
      packet.l6();
    }
    yield* close($this, CloseReason().z5a(Codes_TOO_BIG_getInstance(), 'Frame is too big: ' + size + '. Max size is ' + $this.p5b().toString()), $completion);
    throw FrameTooBigException().v5c(fromInt(size));
  }
  return Unit_instance;
}
function processIncomingExtensions($this, frame) {
  // Inline function 'kotlin.collections.fold' call
  var accumulator = frame;
  var _iterator__ex2g4s = $this.w5c().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var current = accumulator;
    accumulator = element.x5c(current);
  }
  return accumulator;
}
function processOutgoingExtensions($this, frame) {
  // Inline function 'kotlin.collections.fold' call
  var accumulator = frame;
  var _iterator__ex2g4s = $this.w5c().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var current = accumulator;
    accumulator = element.y5c(current);
  }
  return accumulator;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.r5c_1 = Pong().g5d(new Int8Array(0), NonDisposableHandle_instance);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function DefaultWebSocketSessionImpl$start$slambda($incomingJob, $outgoingJob, this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* $incomingJob.ix($completion);
    yield* $outgoingJob.ix($completion);
    this$0.z5b_1.mx();
    return Unit_instance;
  }, 1);
}
function DefaultWebSocketSessionImpl$runIncomingProcessor$slambda(this$0, $ponger) {
  return constructCallableReference(function *($this$launch, $completion) {
    var firstFrame = null;
    var frameBody = null;
    var closeFramePresented = false;
    try {
      // Inline function 'kotlinx.coroutines.channels.consumeEach' call
      var tmp0 = this$0.w5b_1.q5b();
      $l$block_1: {
        // Inline function 'kotlinx.coroutines.channels.consume' call
        var cause = null;
        try {
          var _iterator__ex2g4s = tmp0.p1();
          while (yield* _iterator__ex2g4s.n1a($completion)) {
            var e = _iterator__ex2g4s.r1();
            $l$block_0: {
              // Inline function 'io.ktor.util.logging.trace' call
              var this_0 = get_LOGGER();
              if (get_isTraceEnabled(this_0)) {
                var tmp$ret$5 = 'WebSocketSession(' + toString($this$launch) + ') receiving frame ' + e.toString();
                this_0.b4u(tmp$ret$5);
              }
              if (e instanceof Close()) {
                if (!this$0.r5b().u1a()) {
                  var tmp = this$0.r5b();
                  var tmp1_elvis_lhs = readReason(e);
                  yield* tmp.b1b(Close().q5c(tmp1_elvis_lhs == null ? get_NORMAL_CLOSE() : tmp1_elvis_lhs), $completion);
                }
                closeFramePresented = true;
                return Unit_instance;
              } else {
                if (e instanceof Pong()) {
                  var tmp2_safe_receiver = this$0.x5b_1.kotlinx$atomicfu$value;
                  if (tmp2_safe_receiver == null)
                    null;
                  else
                    yield* tmp2_safe_receiver.b1b(e, $completion);
                } else {
                  if (e instanceof Ping())
                    yield* $ponger.b1b(e, $completion);
                  else {
                    yield* /*#__NOINLINE__*/checkMaxFrameSize(this$0, frameBody, e, $completion);
                    if (!e.f5b_1) {
                      if (firstFrame == null) {
                        firstFrame = e;
                      }
                      if (frameBody == null) {
                        frameBody = BytePacketBuilder();
                      }
                      writeFully(frameBody, e.h5b_1);
                      break $l$block_0;
                    }
                    if (firstFrame == null) {
                      yield* this$0.b5c_1.b1b(processIncomingExtensions(this$0, e), $completion);
                      break $l$block_0;
                    }
                    writeFully(ensureNotNull(frameBody), e.h5b_1);
                    var defragmented = Companion_getInstance_0().i5d(true, firstFrame.g5b_1, readByteArray(build(frameBody)), firstFrame.j5b_1, firstFrame.k5b_1, firstFrame.l5b_1);
                    firstFrame = null;
                    yield* this$0.b5c_1.b1b(processIncomingExtensions(this$0, defragmented), $completion);
                  }
                }
              }
            }
          }
          break $l$block_1;
        } catch ($p) {
          if ($p instanceof Error) {
            var e_0 = $p;
            cause = e_0;
            throw e_0;
          } else {
            throw $p;
          }
        }
        finally {
          cancelConsumed(tmp0, cause);
        }
      }
    } catch ($p_0) {
      if ($p_0 instanceof ClosedSendChannelException()) {
        var _unused_var__etf5q3 = $p_0;
      } else {
        if ($p_0 instanceof Error) {
          var cause_0 = $p_0;
          $ponger.n1b();
          this$0.b5c_1.l1b(cause_0);
        } else {
          throw $p_0;
        }
      }
    }
    finally {
      $ponger.n1b();
      var tmp0_safe_receiver = frameBody;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.l6();
      }
      this$0.b5c_1.n1b();
      if (!closeFramePresented) {
        yield* close(this$0, CloseReason().z5a(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), $completion);
      }
    }
    return Unit_instance;
  }, 1);
}
function DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      tmp = yield* /*#__NOINLINE__*/outgoingProcessorLoop(this$0, $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof ClosedSendChannelException()) {
        var _unused_var__etf5q3 = $p;
        tmp_0 = Unit_instance;
      } else {
        if ($p instanceof ClosedReceiveChannelException()) {
          var _unused_var__etf5q3_0 = $p;
          tmp_0 = Unit_instance;
        } else {
          if ($p instanceof CancellationException()) {
            var _unused_var__etf5q3_1 = $p;
            tmp_0 = yield* /*#__NOINLINE__*/sendCloseSequence(this$0, CloseReason().z5a(Codes_NORMAL_getInstance(), ''), VOID, $completion);
          } else {
            if ($p instanceof ChannelIOException()) {
              var _unused_var__etf5q3_2 = $p;
              tmp_0 = Unit_instance;
            } else {
              if ($p instanceof Error) {
                var cause = $p;
                this$0.c5c_1.lx(CancellationException().p('Failed to send frame', cause));
                yield* closeExceptionally(this$0.w5b_1, cause, $completion);
                return Unit_instance;
              } else {
                throw $p;
              }
            }
          }
        }
      }
      tmp = tmp_0;
    }
    finally {
      this$0.c5c_1.p1b();
      yield* close(this$0.w5b_1, VOID, $completion);
    }
    return Unit_instance;
  }, 1);
}
function DefaultWebSocketSessionImpl$runOrCancelPinger$slambda(this$0) {
  return constructCallableReference(function *(it, $completion) {
    yield* /*#__NOINLINE__*/sendCloseSequence(this$0, it, IOException().k4i('Ping timeout'), $completion);
    return Unit_instance;
  }, 1);
}
var DefaultWebSocketSessionImplClass;
function DefaultWebSocketSessionImpl() {
  if (DefaultWebSocketSessionImplClass === VOID) {
    class $ {
      constructor(raw, pingIntervalMillis, timeoutMillis, incomingFramesConfig, outgoingFramesConfig) {
        Companion_getInstance_1();
        this.w5b_1 = raw;
        this.x5b_1 = atomic$ref$1(null);
        this.y5b_1 = CompletableDeferred();
        this.z5b_1 = Job();
        this.a5c_1 = this.w5b_1.bw().nm(Key_instance).pm(this.z5b_1).pm(new (CoroutineName())('ws-default'));
        this.b5c_1 = from(Factory_getInstance(), incomingFramesConfig);
        this.c5c_1 = from(Factory_getInstance(), outgoingFramesConfig);
        this.d5c_1 = atomic$boolean$1(false);
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.e5c_1 = ArrayList().p2();
        this.f5c_1 = atomic$boolean$1(false);
        this.g5c_1 = pingIntervalMillis;
        this.h5c_1 = timeoutMillis;
        this.i5c_1 = this.y5b_1;
      }
      bw() {
        return this.a5c_1;
      }
      q5b() {
        return this.b5c_1;
      }
      r5b() {
        return this.c5c_1;
      }
      w5c() {
        return this.e5c_1;
      }
      o5b(value) {
        this.w5b_1.o5b(value);
      }
      p5b() {
        return this.w5b_1.p5b();
      }
      m5b() {
        return this.i5c_1;
      }
      n5b(negotiatedExtensions) {
        if (!this.f5c_1.atomicfu$compareAndSet(false, true)) {
          // Inline function 'kotlin.error' call
          var message = 'WebSocket session ' + toString(this) + ' is already started.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'io.ktor.util.logging.trace' call
        var this_0 = get_LOGGER();
        if (get_isTraceEnabled(this_0)) {
          var tmp$ret$2 = 'Starting default WebSocketSession(' + toString(this) + ') ' + ('with negotiated extensions: ' + joinToString(negotiatedExtensions));
          this_0.b4u(tmp$ret$2);
        }
        this.e5c_1.u2(negotiatedExtensions);
        runOrCancelPinger(this);
        var incomingJob = runIncomingProcessor(this, ponger(this, this.r5b()));
        var outgoingJob = runOutgoingProcessor(this);
        launch(this, VOID, VOID, DefaultWebSocketSessionImpl$start$slambda(incomingJob, outgoingJob, this));
      }
      *l4k($completion) {
        yield* this.w5b_1.l4k($completion);
        return Unit_instance;
      }
    }
    protoOf($).s5b = send;
    initMetadataForClass($, 'DefaultWebSocketSessionImpl', VOID, VOID, [DefaultWebSocketSession(), WebSocketSession()], [1, 0, 2]);
    DefaultWebSocketSessionImplClass = $;
  }
  return DefaultWebSocketSessionImplClass;
}
var properties_initialized_DefaultWebSocketSession_kt_6cjlhc;
function _init_properties_DefaultWebSocketSession_kt__469s0y() {
  if (!properties_initialized_DefaultWebSocketSession_kt_6cjlhc) {
    properties_initialized_DefaultWebSocketSession_kt_6cjlhc = true;
    LOGGER = KtorSimpleLogger('io.ktor.websocket.WebSocket');
    IncomingProcessorCoroutineName = new (CoroutineName())('ws-incoming-processor');
    OutgoingProcessorCoroutineName = new (CoroutineName())('ws-outgoing-processor');
    NORMAL_CLOSE = CloseReason().z5a(Codes_NORMAL_getInstance(), 'OK');
    var tmp0_safe_receiver = get_OUTGOING_CHANNEL_CAPACITY();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new (ChannelConfig())(tmp0_safe_receiver, ChannelOverflow_SUSPEND_getInstance());
    }
    OUTGOING_CHANNEL_CONFIG = tmp;
  }
}
//region block: exports
export {
  DefaultWebSocketSession_0 as DefaultWebSocketSessionmehckluw85jl,
  DefaultWebSocketSession as DefaultWebSocketSession3h8506yqzs5fx,
  get_LOGGER as get_LOGGER1pnacb4n2g1eb,
};
//endregion

//# sourceMappingURL=DefaultWebSocketSession.mjs.map
